import React, { useEffect, useState } from 'react'
import OperatorDropdown from './operatordropdown';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import moment from 'moment';

const MonthYearFilter = (props:any) => {
    const { firstFilterProps } = props;
    const [currentOperator, setCurrentOperator] = useState({
        text: 'Is equal to',
        operator: 'eq',
      });
      let customOperators = [
        {
          text: 'Is equal to',
          operator: 'eq',
        },
        {
          text: 'Is after',
          operator: 'gt',
        },
        {
          text: 'Is before',
          operator: 'lt',
        }
      ];
      let operator = firstFilterProps.operator;

      const value = firstFilterProps.value || null;
      
      useEffect(() => {
        if (firstFilterProps.operator) {
          let newOperator = customOperators.filter(
            (item) => item.operator === firstFilterProps?.operator
          );
          if (newOperator?.length > 0) {
            operator = newOperator[0];
          } else {
            operator = {
              text: 'Is equal to',
              operator: 'eq',
            };
          }
        }
        setCurrentOperator(operator);
      }, [operator]);

      const operatorClick = (ev: any) => {
        let newOperator = ev.value.operator;
        firstFilterProps?.onChange({
          value: undefined,
          operator: newOperator,
          syntheticEvent: ev.syntheticEvent,
        });
        setCurrentOperator(ev.value);
      };
      const onDateChange = (event: any) => {
        firstFilterProps?.onChange({
          value: event?.value ? new Date(moment(event?.value, "YYYY-MM-DD").utc().startOf('month').toDate())  : undefined,
          operator: currentOperator?.operator,
          syntheticEvent: event.syntheticEvent,
        });
      };
      

        return (
          <div className="custom-filter-ui">
            <OperatorDropdown
              currentOperator={currentOperator}
              customOperators={customOperators}
              operatorClick={operatorClick}
            />
            <DatePicker
              value={value ? value : undefined}
              format={'MMM yyyy'}
              placeholder={'MMM yyyy'}
              onChange={onDateChange}
            />
          </div>
        );
}

export default MonthYearFilter